import StoreUtil from "../store.util.js";
const mutations = {
  SET_ALL_EMPLOYEES(state, payload) {
    state.employeeList = StoreUtil.updateState(state.employeeList, payload);
  },
};

export default mutations;
